import React, { useEffect, useState } from 'react';
import { TextField, Button, Typography, IconButton, Grid, FormControl, InputLabel, Select, MenuItem, FormLabel, RadioGroup, FormControlLabel, Radio, Autocomplete, Box, Paper, Card, Chip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useForm, Controller, FormProvider } from 'react-hook-form';
import Swal from "sweetalert2";
import ImgUploadDialog from "../../components/ImgUpload/imgUpload";
import AddToPhotosIcon from '@mui/icons-material/AddToPhotos';
import { CrudServices } from "./CrudServices";
import { isMobile } from "react-device-detect";
import { BookingService } from "../Booking/Service";
import { Helpers } from '../../services/Helpers';
import Loading from '../../components/Loader/Loading';
import TextEditor from '../../utils/QuillTextEditor';
import { useNavigate, useParams } from 'react-router-dom';
import PageHeaderLayout from '../../components/Layout/PageHeaderLayout';
import { PermissionGuard } from '../../components/PermissionGuard';
import { ArrowBack, Edit } from '@mui/icons-material';
import noImage from '../../assets/images/no_image_available.png'

const ViewService = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [isEditing, setIsEditing] = useState(false);
    const serviceInitialState = {
        title: '',
        shortTitle: '',
        shortDescription: '',
        description: '',
        image: '',
        categoryId: '',
        serviceCategoryId: '',
        parentServiceId: 0,
        serviceType: 'parent',
        sacId: '',
        brands:[],

    };

    const [serviceData, setServiceData] = useState(serviceInitialState)

    const serviceFormMethod = useForm({
        mode: "onChange",
        defaultValues: serviceData
    });
    const { register, control, handleSubmit, reset, setValue, watch, formState: { errors, isDirty, dirtyFields } } = serviceFormMethod;


    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [categoryList, setCategoryList] = useState([]);
    const [sacList, setSacList] = useState([]);
    const fetchSacList = async () => {
        try {
            const response = await CrudServices.fetchSacCodes();
            console.log("response", response);
            if (response.success == '1') {
                setSacList(response.data);
            }
        } catch (error) {
            console.log("error", error);
        }
    }


    const fetchCategoryList = async () => {
        try {
            const categoryListResponse = await BookingService.categoryList();
            //   console.log("category list Response:",categoryListResponse);
            if (categoryListResponse.success === 1) {
                setCategoryList(categoryListResponse.data)
            }
        } catch (error) {

        }
    }

    const fetchServiceData = async () => {
        setIsLoading(true);
        try {
            const serviceDataResponse = await CrudServices.fetchServiceData(id);
            // console.log("service data Response:",serviceDataResponse);
            if (serviceDataResponse.success == '1') {
                const rowData = serviceDataResponse.data;
                const formattedData = {
                    id: rowData?.id,
                    title: rowData.title,
                    shortTitle: rowData.shortTitle,
                    // shortDescription: rowData?.shortDescription,
                    description: rowData.description,
                    image: rowData.images,
                    categoryId: rowData?.ServiceCategoryRels[0]?.ServiceCategory.parentId,
                    serviceCategoryId: rowData?.ServiceCategoryRels[0]?.serviceCategoryId,
                    parentServiceId: rowData.parentServiceId,
                    sacId: rowData.sacId,
                    serviceType: rowData.parentServiceId > 0 ? 'child' : 'parent',
                    brands: rowData.brands || [],
                };
                setServiceData(formattedData);
                // Reset form with the new data and mark as pristine
                reset(formattedData, { isDirty: false });

                // if (formattedData.parentServiceId > 0) {
                //     setValue('serviceType', 'child', { shouldDirty: false });
                //     setValue('categoryId', formattedData.categoryId, { shouldDirty: false });
                //     setValue('serviceCategoryId', formattedData.serviceCategoryId, { shouldDirty: false });
                // }
            }
        } catch (error) {

        } finally {
            setIsLoading(false);
        }
    }

    /*================= on component load==================== */

    useEffect(() => {
        fetchSacList()
        fetchCategoryList();
        fetchServiceData();
    }, []);
    /*================= on category selection==================== */
    const [subCategoryList, setSubCategoryList] = useState([]);
    const categoryId = watch('categoryId');
    const fetchSubCategoryList = async () => {
        // setIsLoading(true);
        try {
            const subCategoryListResponse = await BookingService.subCategoryList({ categoryId: categoryId });
            //   console.log("sub category list Response:",subCategoryListResponse);
            if (subCategoryListResponse.success === 1) {
                setSubCategoryList(subCategoryListResponse.data)
            }
        } catch (error) {

        } finally {
            // setIsLoading(false);
        }
    }
    useEffect(() => {
        if (categoryId) {
            fetchSubCategoryList();
        }
    }, [categoryId])
    /*============== on SubCategory selection ============ */
    const subCategoryId = watch('serviceCategoryId');
    const serviceType = watch('serviceType', 'parent');
    const [parentServices, setParentServices] = useState([]);
    useEffect(() => {
        if (subCategoryId && serviceType == 'child') {
            // setValue('parentServiceId',0)
            setParentServices([]);
            const fetchServiceList = async () => {
                setIsLoading(true);
                try {
                    const serviceListResponse = await CrudServices.serviceListBySubCategory(subCategoryId);
                    // console.log("service list Response:",serviceListResponse);
                    if (serviceListResponse.success === 1) {
                        setParentServices(serviceListResponse.data)
                    }
                } catch (error) {

                } finally {
                    setIsLoading(false);
                }
            }
            fetchServiceList();
        }
    }, [subCategoryId, serviceType])

    return (
        <>
            {isLoading && <Loading />}
            <PageHeaderLayout headerTitle={`Service Detail's`}>
                <Button variant='contained'
                    onClick={() => navigate(-1)}
                    sx={{ height: "30px", marginTop: "10px" }} startIcon={<ArrowBack />}
                >
                    Back
                </Button>
            </PageHeaderLayout>
            <FormProvider {...serviceFormMethod}>
                <Grid container spacing={1}>
                    <Grid item xs={12} md={8}>
                        <Card sx={{ p: 2 }}>
                            <Grid container spacing={1} >
                                {isLoading || isSubmitting && <Loading />}
                                <Grid item xs={12} >
                                    <Grid container spacing={5}>
                                        <Grid item sx={{ pt: '5%!important', display: { xs: 'block', sm: 'flex' }, alignItems: 'center', gap: 1 }} xs={12}>
                                            <Typography sx={{ fontSize: '0.85rem', mt: { xs: '5%', sm: '0' }, fontWeight: 600, width: 'fit-content', minWidth: { xs: '45%', sm: '0' } }}>Service Type  :</Typography>
                                            <FormControl component="fieldset">
                                                <RadioGroup value={serviceData.serviceType} row >
                                                    <FormControlLabel value="parent"
                                                        control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: '0.9rem' } }} disabled />}
                                                        sx={{
                                                            '& .MuiFormControlLabel-label': {
                                                                fontSize: '0.75rem'
                                                            }
                                                        }} label="Parent Service"
                                                    />
                                                    <FormControlLabel value="child"
                                                        control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: '0.9rem' } }} disabled />}
                                                        sx={{
                                                            '& .MuiFormControlLabel-label': {
                                                                fontSize: '0.75rem'
                                                            }
                                                        }} label="Child Service"
                                                    />
                                                </RadioGroup>
                                            </FormControl>
                                        </Grid>
                                        <Grid item sx={{ pt: '1%!important' }} xs={12} sm={6}>
                                            <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>Category </Typography>
                                            <TextField
                                                value={categoryList.find(cat => cat.id == serviceData.categoryId)?.title || ''}
                                                InputProps={{
                                                    style: { fontSize: '0.75rem' },
                                                }}
                                                disabled
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                            />
                                        </Grid>
                                        <Grid item sx={{ pt: '1%!important' }} xs={12} sm={6}>
                                            <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>Sub Category </Typography>
                                            <TextField
                                                value={subCategoryList.find(subCat => subCat.id == serviceData.serviceCategoryId)?.title || ''}
                                                InputProps={{
                                                    style: { fontSize: '0.75rem' },
                                                }}
                                                disabled
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                            />
                                        </Grid>
                                        <Grid item sx={{ pt: '1%!important' }} xs={12} sm={6}>
                                            <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>SAC Code </Typography>
                                            <TextField
                                                value={sacList.find(item => item.id === serviceData.sacId)?.sac || ''}
                                                // label="SAC Code"
                                                variant="outlined"
                                                size="small"
                                                disabled
                                                inputProps={{
                                                    style: { fontSize: '0.75rem' }
                                                }}
                                                fullWidth
                                            />
                                        </Grid>
                                        {serviceType === 'child' && (
                                            <Grid item sx={{ pt: '1%!important' }} xs={isMobile ? 12 : 6}>
                                                <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>Parent Service </Typography>
                                                <TextField
                                                    // label={'Parent Service'}
                                                    value={parentServices.filter(parent => parent.masterServiceId == serviceData.parentServiceId)[0]?.title}
                                                    inputProps={{
                                                        style: { fontSize: '0.75rem' }
                                                    }}
                                                    disabled
                                                    variant="outlined"
                                                    fullWidth
                                                    size="small"
                                                >
                                                </TextField>

                                            </Grid>
                                        )}
                                        {serviceType === 'parent' && (
                                            <Grid item sx={{ pt: '1%!important' }} xs={isMobile ? 12 : 6}>
                                                <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>Service Brands </Typography>
                                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, border: '1px solid lightGray', p: '1%', borderRadius: '.25rem', minHeight: '2.1rem' }}>
                                                    {(serviceData?.brands).length> 0 && (serviceData.brands).map(brand => {
                                                        return (
                                                            <Chip
                                                                key={id}
                                                                label={brand.brandDetail.title || ''}
                                                                color="primary"
                                                                variant="outlined"
                                                                size="small"
                                                                sx={{ fontSize: '.65rem' }}
                                                            />
                                                        )
                                                    })}
                                                </Box>

                                            </Grid>
                                        )}
                                        <Grid item sx={{ pt: '1%!important' }} xs={12} sm={6}>
                                            <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>Service Name </Typography>
                                            <TextField
                                                value={serviceData.title}
                                                // label="Service Name"
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                disabled
                                                inputProps={{
                                                    style: { fontSize: '0.75rem' }
                                                }}
                                            />
                                        </Grid>
                                        <Grid item sx={{ pt: '1%!important' }} xs={12} sm={6}>
                                            <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>Service Short Title </Typography>
                                            <TextField
                                                value={serviceData.shortTitle}
                                                // label="Service Short Title*"
                                                variant="outlined"
                                                size="small"
                                                disabled
                                                inputProps={{
                                                    style: { fontSize: '0.75rem' }
                                                }}
                                                fullWidth
                                            />
                                        </Grid>
                                        {/* <Grid item sx={{pt:'1%!important',display:'flex',alignItems:'center'}} xs={12}>
                                            <Typography sx={{fontSize:'0.85rem',fontWeight:600,width:'40%'}}>Service Short Description <Box component={'span'} sx={{color:'#d32f2f'}}>*</Box></Typography>
                                            <TextField
                                                value={serviceData.shortDescription}
                                                // label="Service Description"
                                                variant="outlined"
                                                disabled
                                                size="small"
                                                inputProps={{
                                                    style:{fontSize:'0.75rem'}
                                                }}
                                                fullWidth 
                                            />
                                        </Grid> */}
                                        <Grid item sx={{ pt: '1%!important' }} xs={12}>
                                            <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>Service Detailed Description </Typography>

                                            <TextEditor
                                                fieldName='description'
                                                rules={{ required: 'description field should not be empty' }}
                                                imageFolder='service'
                                                hideToolBar={true}
                                                disableEditor={true}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Card sx={{ p: 3 }}>
                            <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600 }}>
                                Service Image <Box component="span" sx={{ color: 'error.main' }}>*</Box>
                            </Typography>


                            <Box sx={{ mb: 2, boxShadow: '0 0 5px rgba(0,0,0,0.1)', borderRadius: '5px', display: 'flex', justifyContent: 'center' }}>
                                <img
                                    src={serviceData?.image ? `${Helpers.ImagePathUrl()}/service/md/${serviceData?.image}` : noImage}
                                    alt="Service"
                                    style={{ maxWidth: '100%', height: 'auto' }}
                                />
                            </Box>
                            <Box sx={{ mt: 3, textAlign: 'center' }}>
                                <Button
                                    onClick={() => navigate(`/admin/service/${id}`)}
                                    variant="contained"
                                    color="warning"
                                    size='small'
                                    startIcon={<Edit />}
                                >
                                    Edit Service Detail's
                                </Button>
                            </Box>

                        </Card>
                    </Grid>
                </Grid>
            </FormProvider>
        </>
    )
}


export default ViewService;
